export default __webpack_public_path__ + "static/media/gallery-temp.e82f8c7f.jpg";